import * as React from 'react'

import {IconProps} from '.'

function Calendar({color, size, isFilled}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={isFilled ? color : 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 1.5V3.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 1.5V3.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5.5H13.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 7.99963H7.5L6.5 9.24963C6.66443 9.24963 6.82631 9.29018 6.97133 9.36768C7.11635 9.44518 7.24001 9.55724 7.33139 9.69394C7.42276 9.83064 7.47901 9.98776 7.49516 10.1514C7.51132 10.315 7.48687 10.4801 7.424 10.632C7.36112 10.784 7.26175 10.918 7.13469 11.0224C7.00763 11.1268 6.85679 11.1982 6.69554 11.2303C6.53429 11.2625 6.3676 11.2544 6.21023 11.2067C6.05286 11.1591 5.90966 11.0734 5.79332 10.9572"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 8.74963L10 7.99963V11.2496"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Calendar
